<template>
  <div class="white_box">
    <div
      class="accordion_head"
      @click="$emit('selected')"
    >
      <div>
        <svg-vue
          class="dropdown"
          icon="icons/arrow_box"
        />
        <h3>
          <slot name="heading" />
        </h3>
      </div>

      <div
        v-if="valid"
        class="section_state success"
      >
        <svg-vue
          class="state"
          icon="icons/checkmark"
        />
      </div>
      <div
        v-else
        class="section_state warning"
      >
        <svg-vue
          class="state warning"
          icon="icons/hazard_triangle"
        />
      </div>
    </div>
    <accordion-transition>
      <div
        v-if="open"
        class="accordion_body"
      >
        <slot />
      </div>
    </accordion-transition>
  </div>
</template>

<script>
import AccordionTransition from "../../../../../views/reports/components/global/transitions/AccordionTransition";

export default {
  components: {
    AccordionTransition
  },
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    valid: {
      type: Boolean,
      required: true,
    }
  },
  emits: ['selected'],
}
</script>

<style lang="scss" scoped>
.white_box {
  margin-bottom: 1rem;
  padding: 1rem 1.5rem;
}

.accordion_head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;

  > div {
    display: flex;
    align-items: center;

    > .dropdown {
      height: 1.5rem;
      width: 1.5rem;
      margin-right: 1rem;
    }

    > h3 {
      font-weight: 500;
      line-height: 1;
      letter-spacing: -0.042em;
      color: #040707;
      font-size: 1.5rem;
      margin-bottom: 0;
    }
  }

  > .section_state {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2rem;
    height: 2rem;
    border-radius: 50%;

    &.success {
      background-color: #37B2A8;

      > .state {
        width: 18px;
        height: 18px;
      }
    }

    &.warning {
      background-color: #FFD673;

      > .state {
        width: 16px;
        height: 16px;
      }
    }


  }
}

.accordion_body {
  margin-top: 1rem;
  transition: 300ms;

  :deep(.recommendations) {
    margin-top: 2rem;

    > span {
      font-size: 0.875rem;
      line-height: 1.72;
      letter-spacing: -0.00715em;
      color: #4E4E54;
      font-weight: 700;
    }

    li {
      font-size: 0.875rem;
      line-height: 1.72;
      letter-spacing: -0.00715em;
      color: #4E4E54;

    }

    p.sub {
      margin-left: .5rem;
      margin-bottom: 0;
    }
  }
}
</style>
